import { BehaviorSubject, combineLatest } from "rxjs";
import { filter } from "rxjs/operators";
import { FiltersAbstractService } from "src/app/common-page-components/classes/filters-abstract-service";
import { ComboStoreComponent, EventAthleteResultsCombo, YesNotCombo } from "src/app/common-page-components/stores/filters-store/filters-store";
import { FiltersAthleteGeneralService } from "../../services/filters-athlete-general.service";
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../services/filters-athlete-general.service";
export class AthleteWcupRankingFiltersFinalsService extends FiltersAbstractService {
    constructor(common_service) {
        super();
        this.common_service = common_service;
        /**
         * Categories combo from general athlete to get the athlete categories.
         *
         * @memberof AthleteWcupRankingFiltersFinalsService
         */
        this.athleteCategoriesCombo = this.common_service.athleteCategoriesCombo;
        /**
         * Categories combo from general athlete to get the athlete categories.
         *
         * @memberof AthleteWcupRankingFiltersFinalsService
         */
        this.categoriesCombo = new ComboStoreComponent('Categories: ', 'CatName', 'wcrup-category-combo', undefined, undefined, undefined, undefined);
        /**
         * A lock to only dispatch the events on the method getDataStreamWithFilters when categories are ready and filtered.
         *
         * @memberof AthleteWcupRankingFiltersFinalsService
         */
        this.categoriesReady = new BehaviorSubject(false);
        /**
         * Event type combo.
         *
         * @memberof AthleteWcupRankingFiltersFinalsService
         */
        this.eventTypeCombo = new EventAthleteResultsCombo("Event:", "event-results-combo");
        /**
         * Podiums only filter.
         *
         * @memberof AthleteWcupRankingFiltersService
         */
        this.podiumsOnly = new YesNotCombo("Podiums", "wcup-podiums-only", { Name: "No", Value: false });
        /**
         * The filters of the BootstrapAthleteWcupRankingComponent page.
         *
         * @memberof BootstrapAthleteWcupRankingComponent
         */
        this.filtersType = [
            this.categoriesCombo.filterInfo,
            this.eventTypeCombo.filterInfo,
            this.podiumsOnly.filterInfo
        ];
        this.eventTypeCombo.setData([].concat(...(this.eventTypeCombo['extraOptions']).map(value => value.item).filter(value => ['Individual', 'Mixed Team'].indexOf(value.Name) != -1)), { Name: "Individual", Value: 0 });
        const categoriesToSet = [].concat(...this.athleteCategoriesCombo.data.filter(value => ['RM', 'RW', 'CM', 'CW'].indexOf(value.Cat) != -1));
        this.categoriesCombo.setData(categoriesToSet, categoriesToSet[0]);
    }
    /**
     * {@inheritdoc}
     *
     * @return {*}  {void}
     * @memberof AthleteWcupRankingFiltersService
     */
    generateDefaultValues() {
        return;
    }
    /**
     *
     * @inheritdoc
     * @returns {import("rxjs").Observable<any>}
     * @memberof AthleteWcupRankingFiltersService
     */
    getDataStreamWithFilters() {
        return combineLatest([this.categoriesReady.asObservable(), this.categoriesCombo.comboData, this.eventTypeCombo.comboData, this.podiumsOnly.comboData]).pipe(filter(a => a[0] === true), map(a => {
            return [a[1], a[2], a[3]];
        }));
    }
}
AthleteWcupRankingFiltersFinalsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AthleteWcupRankingFiltersFinalsService_Factory() { return new AthleteWcupRankingFiltersFinalsService(i0.ɵɵinject(i1.FiltersAthleteGeneralService)); }, token: AthleteWcupRankingFiltersFinalsService, providedIn: "root" });
